import React, { Component } from 'react'
import { Input } from 'hljd'
import SearchBar from '@common/SearchBar'
import store from './store'

const Item = SearchBar.Item

export default class extends Component {
  render() {
    return (
      <SearchBar store={store} noNeed={['title']}>
        <Item name="title">
          <Input placeholder="关联客照" />
        </Item>
      </SearchBar>
    )
  }
}
